export default __webpack_public_path__ + "static/media/Uang1.3a731c2b.png";